module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-top-stone-path-background.909a476e.png";